import axios from 'axios';
import { history } from 'ice';
import React, { useEffect, useState } from 'react';

import useFetchReduxUserData from '@/redux/useFetchReduxUserData';

import commonhelper from '../../../lib/commonhelper';
import client from '../../../lib/feathers';
import MobileHomeIcon from '../components/MobileHomeIcon';
import MobileHomeBanner from '../MobileHomeBanner';
import styles from './MobileHome.module.scss';

const MobileHome = (props) => {
  const [allow, setAllow] = useState([]);
  const [unallow, setUnallow] = useState([]);
  // const [userHousehold, setUserHousehold] = useState([]);
  // console.log("========userHousehold",userHousehold)
  useEffect(() => {
    client
      .reAuthenticate()
      .then((data) => {
        console.log('==re login mobile home ok', data);
        // 20220720 點數管理不顯示於前台畫面與公設合併
        const newAllow = structuredClone(
          data.user.allow
            .filter((item) => {
              return item.name !== '點數管理';
            })
            .filter((item) => {
              return item.name !== '問卷管理';
            })
        );
        const arr = newAllow.map((x) => {
          if (x.children) {
            for (let i = 0; i < x.children.length; i++)
              x.children[i].path = x.children[i].path.replace(
                '/ezpro',
                '/mobile'
              );
          }
          return x;
        });
        setAllow(arr);
        setUnallow(data.user?.unlaunchedAppFeatures);
        // setUserHousehold(data.user.householdNumbers[0])
        // 設置token
        commonhelper.getToken().then((data) => {
          console.log('==token object:', data);
          if (!data) {
            data = {
              os: 'ios',
              token: 'dummytoken',
            };
            console.log('==DUMMY token object:', data, '要記得改Time!!');
          }

          axios('/ezcon/api/combineToken', {
            method: 'POST',
            headers: { authorization: window.localStorage['feathers-jwt'] },
            data, // :{ os:'ios',token }
          })
            .then(() => {
              console.log('==set Token OK');
            })
            .catch((error) => {
              console.error('==set Token Error', error);
            });
        });
      })
      .catch((err) => {
        console.log('==re login mobile home  fail', err);
        const nowRoute = window.location.href.split('#')[1].split('?')[0];
        if (nowRoute.includes('/mobile/home'))
          if (commonhelper.isApp()) {
            //
            commonhelper.loadPath('/com');
          } else {
            history.push('/mobile/user/login');
          }
      });
  }, []);

  const judgeClass = (name) => {
    // app首頁訊息顯示數量或樣式
    // console.log(name)
    const outObj = {
      id: null,
      class: '',
      count: null,
    };
    if (
      !props ||
      !props.msgDatas ||
      !props.msgDatas.data ||
      !props.msgDatas.data[0]
    )
      return outObj;
    outObj.id = props.msgDatas.data[0].userId;
    let outName = '';
    switch (name) {
      case '公告事項':
        outName = 'announcement';
        break;
      case '行事曆':
        outName = 'calendar';
        break;
      case '郵件包裹':
        outName = 'postalRegistration';
        break;
      case '寄物管理':
        outName = 'deposit';
        break;
      case '公設預約':
        outName = 'publicAppointmentHour';
        break;
      case '訪客管理':
        outName = 'visitorAppointmentRegistration';
        break;
      case '投票活動':
        outName = 'vote';
        break;
      case '報修服務':
        outName = 'fix';
        break;
      case '繳費系統':
        outName = 'pay';
        break;
      case '訪客門禁':
        outName = 'visitorAppointmentRegistration';
        break;
      case '意見反應':
        outName = 'feedback';
        break;
      case '瓦斯抄錶':
        outName = 'gas';
        break;
      case '智慧信箱':
        outName = 'smartMail';
        break;
      case '汽車充電樁':
        outName = 'chargingPile';
        break;
      default:
        outName = '';
    }
    outObj.class = outName;
    if (outName === '') return outObj;
    const tarArr = props.msgDatas.data.filter((i) => {
      // 20220318增加訪客及包裹僅新增時顯示推播
      if (i.class === 'visitorAppointmentRegistration') {
        return i.class === outName && i.content.indexOf('訪客預約成功') >= 0;
      }
      if (i.class === 'postalRegistration') {
        return i.class === outName && i.content.indexOf('您有') >= 0;
      }
      if (i.class === 'deposit') {
        return i.class === outName && i.content.indexOf('您有') >= 0;
      }
      return i.class === outName;
    });
    outObj.count = tarArr.length;

    if (name === '公設預約') {
      outObj.count =
        props.msgDatas.data.filter((i) => {
          if (
            i.class === 'publicAppointmentHour' ||
            i.class === 'publicAppointmentCount'
          ) {
            return i.content.indexOf('公設') >= 0;
          }
        }).length + outObj.count;
    }

    if (name === '訪客門禁') {
      outObj.count =
        props.msgDatas.data.filter((i) => {
          if (i.class === 'visitorAppointmentRegistration') {
            return (
              i.content.indexOf('取消預約') >= 0 ||
              i.title.indexOf('訪客已入場') >= 0 ||
              i.title.indexOf('訪客卡片加時成功') >= 0 ||
              i.title.indexOf('訪客辨識加時成功') >= 0 ||
              i.title.indexOf('訪客車牌加時成功') >= 0
            );
          }
        }).length + outObj.count;
    }

    if (name === '訪客管理') {
      outObj.count =
        props.msgDatas.data.filter((i) => {
          if (i.class === 'visitorAppointmentRegistration') {
            return i.title.indexOf('訪客辨識加時成功') >= 0;
          }
        }).length + outObj.count;
    }

    if (name === '郵件包裹') {
      outObj.count =
        props.msgDatas.data.filter((i) => {
          if (i.class === 'postalRegistration') {
            return (
              i.content.indexOf('請快來領取') >= 0 ||
              i.title.indexOf('郵件包裹領取通知') >= 0
            );
          }
        }).length + outObj.count;
    }

    if (name === '寄物管理') {
      outObj.count =
        props.msgDatas.data.filter((i) => {
          if (i.class === outName) {
            return (
              i.title.indexOf('寄物領取通知') >= 0 ||
              i.title.indexOf('寄物管理通知') >= 0
            );
          }
        }).length + outObj.count;
    }

    if (name === '汽車充電樁') {
      outObj.count =
        props.msgDatas.data.filter((i) => {
          if (i.class === outName) {
            return i.title.indexOf('充電樁') >= 0;
          }
        }).length + outObj.count;
    }

    if (outObj.count === 0) {
      outObj.count = null;
    } else {
      outObj.count = 'New';
    }

    // console.log(outObj);
    // return tarArr.length;
    return outObj;
  };

  useFetchReduxUserData();

  return (
    <div className={styles.MobileHome}>
      <div className={styles.MobileHomeBackground} />
      <MobileHomeBanner />
      {allow.map((item, index) => {
        // if (item.children)
        if (
          item.children[item.children.length - 1].name.indexOf('前台') > 0 ||
          item.name === '訪客門禁'
        ) {
          return (
            <MobileHomeIcon
              key={index}
              msg={judgeClass(item.name)}
              name={item.name}
              paths={item.children}
              disable={false}
            />
          );
        }
      })}
      {unallow?.map((item, index) => {
        return (
          <MobileHomeIcon
            key={index}
            name={item.name}
            paths={[item]}
            disable={true}
          />
        );
      })}
    </div>
  );
};

export default MobileHome;
